import { invokeWithSingleContextHeal } from "@wakeloop/adapter-core";
import { isLikelyOpenClawContextLostError } from "../context/openclaw-context-heal.js";
import { invokeOpenClawCliTransport } from "../transport/openclaw-cli-transport.js";
export class OpenClawRuntimeError extends Error {
    code;
    errorType;
    constructor(input) {
        super(input.message);
        this.name = "OpenClawRuntimeError";
        this.code = input.code;
        this.errorType = input.errorType;
    }
}
export async function invokeOpenClawWithSingleContextHeal(input) {
    const result = await invokeWithSingleContextHeal({
        contextId: input.sessionId,
        createRebuildFailedError: (error) => new OpenClawRuntimeError({
            code: "context.rebuild_failed",
            errorType: "adapter",
            message: `context.rebuild_failed: ${toErrorMessage(error)}`,
        }),
        invokeOnce: (sessionId) => invokeOpenClawOnce({
            openClawAgentId: input.openClawAgentId,
            launchContract: input.launchContract,
            openClawTimeoutMs: input.openClawTimeoutMs,
            openClawWorkdir: input.openClawWorkdir,
            env: input.env,
            executionMode: input.executionMode,
            ...(input.onProcessControlEvent
                ? { onProcessControlEvent: input.onProcessControlEvent }
                : {}),
            ...(input.onRuntimeEvent
                ? { onRuntimeEvent: input.onRuntimeEvent }
                : {}),
            prompt: input.prompt,
            sessionId,
        }).then((value) => ({
            contextId: value.sessionId,
            output: value.output,
            ...(value.telemetry ? { telemetry: value.telemetry } : {}),
        })),
        isContextLostError: (error) => isLikelyOpenClawContextLostError(error instanceof Error ? error.message : String(error)),
        onContextLost: input.onContextLost,
    });
    return {
        contextHealed: result.contextHealed,
        output: result.output,
        sessionId: result.contextId,
        ...(result.telemetry ? { telemetry: result.telemetry } : {}),
    };
}
async function invokeOpenClawOnce(input) {
    try {
        return await invokeOpenClawCliTransport({
            openClawAgentId: input.openClawAgentId,
            launchContract: input.launchContract,
            openClawTimeoutMs: input.openClawTimeoutMs,
            openClawWorkdir: input.openClawWorkdir,
            env: input.env,
            ...(input.onProcessControlEvent
                ? { onProcessControlEvent: input.onProcessControlEvent }
                : {}),
            ...(input.onRuntimeEvent ? { onRuntimeEvent: input.onRuntimeEvent } : {}),
            prompt: input.prompt,
            sessionId: input.sessionId,
        });
    }
    catch (error) {
        if (error instanceof OpenClawRuntimeError) {
            throw error;
        }
        if (error &&
            typeof error === "object" &&
            "code" in error &&
            typeof error.code === "string" &&
            "errorType" in error &&
            typeof error.errorType === "string" &&
            error instanceof Error) {
            throw new OpenClawRuntimeError({
                code: error.code,
                errorType: error.errorType,
                message: error.message,
            });
        }
        throw new OpenClawRuntimeError({
            code: "upstream_unreachable",
            errorType: "adapter",
            message: `upstream_unreachable: ${toErrorMessage(error)}`,
        });
    }
}
function toErrorMessage(error) {
    if (error instanceof Error) {
        return error.message;
    }
    return String(error);
}
